import { omit } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Button = (props) => (
	<button
		{...omit(props, ['primary', 'default', 'warning', 'danger', 'info', 'className', 'small'])}
		className={classNames({
			'btn-primary': props.primary,
			'btn-default': props.default,
			'btn-warning': props.warning,
			'btn-danger': props.danger,
			'btn-info': props.info,
      'btn-xs': props.small
		}, 'btn', props.className, {
			'btn-primary': Button.hasDefaultStyle(props)
		})}
    onClick={(e) => {
      if (props.onClick) {
        e.stopPropagation();
        props.onClick(e);
      }
    }}
	>
		{props.children}
	</button>
);

Button.propTypes = {
	primary: PropTypes.bool,
	default: PropTypes.bool,
	warning: PropTypes.bool,
	danger: PropTypes.bool,
	info: PropTypes.bool,
	className: PropTypes.string,
  onClick: PropTypes.func,
  small: PropTypes.bool
};

Button.defaultProps = {

};

Button.hasDefaultStyle = (props) => (
	!(props.primary
	|| props.default
	|| props.warning
	|| props.danger
	|| props.info)
);

export const ButtonBlock = ({ children, className }) => (
  <div className={classNames(className, 'btn-block')}>
    {children}
  </div>
);

ButtonBlock.buttonRight = 'right';
ButtonBlock.center = 'center';

ButtonBlock.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};

export const ButtonBlockLayout = ({ children, className, right }) => (
  <div className={classNames(className, 'btn-block-layout', { right })}>
    {children}
  </div>
);

ButtonBlockLayout.propTypes = {
  className: PropTypes.string,
  right: PropTypes.bool,
  children: PropTypes.any
};



export default Button;
